import { render, staticRenderFns } from "./ProductsSection.vue?vue&type=template&id=9cd6726a&scoped=true&"
import script from "./ProductsSection.vue?vue&type=script&lang=ts&"
export * from "./ProductsSection.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsSection.vue?vue&type=style&index=0&id=9cd6726a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd6726a",
  null
  
)

export default component.exports